import { IPrepaymentMethod } from './index'

export default function fetchTaxes(api: GlobalFetch) {
  return async function() {
    const buildUrl = `/api/v2/misc/payment`
    const response = await api.fetch(buildUrl)
    const responseBody: IData = await response.json()

    const method = responseBody.items[0]

    const switches = [
      'transfer_stripe',
      'transfer_account',
      'transfer_dotpay',
      'transfer_paypal',
      'transfer_p24',
      'transfer_payu',
      'reservation_auto_delete_status',
      'payment_on_place',
    ]

    Object.entries(method).forEach(([key, value]) => {
      if (switches.includes(key)) {
        method[key] = value === '1'
      }
    })

    return {
      ...method,
      p24_clientid: method.p24_clientid === '0' ? '' : method.p24_clientid,
    }
  }
}

export interface IData {
  messages: string[]
  items: IPrepaymentMethod[]
}
